import React from "react";
import noMessagesEmptyIcon from "../../assets/chat/noMessagesEmpty.svg";
import { ChatEmptyState } from "./chatEmptyState";
import { ChatHeader } from "./chatHeader";
import { ChatInput } from "./chatInput";
import { ChatMessages } from "./chatMessages";
import { ChatModals } from "./chatModals";
import { ChatSidebar } from "./chatSidebar";

export const ChatUI = ({
    activeTab,
    setActiveTab,
    inviteSubTab,
    setInviteSubTab,
    connectStatus,
    setConnectStatus,
    onViewProfile,
    contacts,
    loading,
    chatRooms,
    filteredChatRooms,
    invites,
    myInvites,
    invitesLoading,
    selectedUser,
    selectedGroup,
    selectedInvite,
    handleSelectContact,
    handleSelectGroup,
    handleSelectInvite,
    setShowGroupModal,
    setSelectedGroup,
    handleFetchMyInvites,
    handleFetchAllRequests,
    getLastMessageDisplay,
    getLastMessageDisplayForChatRoom,
    formatText,
    t,
    selectedChatType,
    fetchingMessages,
    showGroupInfoModal,
    setShowGroupInfoModal,
    groupInfoRef,
    isAddMemberOpen,
    setIsAddMemberOpen,
    handleAddPeople,
    getAllMembers,
    handleRefreshFlag,
    showRemoveConfirm,
    setShowRemoveConfirm,
    memberToRemove,
    setMemberToRemove,
    fetchGroupMessages,
    loggedInUserName,
    showLeaveConfirm,
    setShowLeaveConfirm,
    handleLeaveGroup,
    isLeaving,
    setIsLeaving,
    messages,
    isDragging,
    handleAcceptInvite,
    handleDeclineInvite,
    chatAreaRef,
    messagesEndRef,
    isMessageFromCurrentUser,
    selectedImage,
    setSelectedImage,
    selectedVideo,
    setSelectedVideo,
    imageCarousel,
    setImageCarousel,
    handleWithdrawDeal,
    dealProcessing,
    getCurrentUserRole,
    setSelectedDealForView,
    setShowViewDealModal,
    viewDealHighlightSection,
    setViewDealHighlightSection,
    setShowModal,
    message,
    setMessage,
    selectedFiles,
    sending,
    uploadingFiles,
    handleSendMessage,
    handleKeyPress,
    handleFileSelect,
    removeFile,
    clearFileSelection,
    fileInputRef,
    showEmojiPicker,
    setShowEmojiPicker,
    inputAreaRef,
    MAX_CHAR_LIMIT,
    showModal,
    showGroupModal,
    showViewDealModal,
    selectedDealForView,
    fetchMessages,
}: {
    activeTab: any;
    setActiveTab: any;
    inviteSubTab: any;
    setInviteSubTab: any;
    contacts: any;
    loading: any;
    chatRooms: any;
    connectStatus: string | null;
    setConnectStatus: React.Dispatch<React.SetStateAction<string | null>>;
    onViewProfile: (profileId?: string | number | null) => void;
    filteredChatRooms: any;
    invites: any;
    myInvites: any;
    invitesLoading: any;
    selectedUser: any;
    selectedGroup: any;
    selectedInvite: any;
    handleSelectContact: any;
    handleSelectGroup: any;
    handleSelectInvite: any;
    setShowGroupModal: any;
    setSelectedGroup: any;
    handleFetchMyInvites: any;
    handleFetchAllRequests: any;
    getLastMessageDisplay: any;
    getLastMessageDisplayForChatRoom: any;
    formatText: any;
    t: any;
    selectedChatType: any;
    fetchingMessages: any;
    showGroupInfoModal: any;
    setShowGroupInfoModal: any;
    groupInfoRef: any;
    isAddMemberOpen: any;
    setIsAddMemberOpen: any;
    handleAddPeople: any;
    getAllMembers: any;
    handleRefreshFlag: any;
    showRemoveConfirm: any;
    setShowRemoveConfirm: any;
    memberToRemove: any;
    setMemberToRemove: any;
    loggedInUserName: any;
    showLeaveConfirm: any;
    setShowLeaveConfirm: any;
    handleLeaveGroup: any;
    isLeaving: any;
    setIsLeaving: any;
    messages: any;
    isDragging: any;
    handleAcceptInvite: any;
    handleDeclineInvite: any;
    chatAreaRef: any;
    messagesEndRef: any;
    isMessageFromCurrentUser: any;
    selectedImage: any;
    setSelectedImage: any;
    selectedVideo: any;
    setSelectedVideo: any;
    imageCarousel: any;
    setImageCarousel: any;
    handleWithdrawDeal: any;
    dealProcessing: any;
    getCurrentUserRole: any;
    setSelectedDealForView: any;
    setShowViewDealModal: any;
    viewDealHighlightSection?: any;
    setViewDealHighlightSection?: any;
    setShowModal: any;
    message: any;
    setMessage: any;
    selectedFiles: any;
    sending: any;
    uploadingFiles: any;
    handleSendMessage: any;
    handleKeyPress: any;
    handleFileSelect: any;
    removeFile: any;
    clearFileSelection: any;
    fileInputRef: any;
    showEmojiPicker: any;
    setShowEmojiPicker: any;
    inputAreaRef: any;
    MAX_CHAR_LIMIT: any;
    showModal: any;
    showGroupModal: any;
    showViewDealModal: any;
    selectedDealForView: any;
    fetchMessages: any;
    fetchGroupMessages: any;
}) => {
    const hasChatSelected =
        (activeTab === 'chats' && !!selectedUser) ||
        (activeTab === 'groups' && !!selectedGroup) ||
        (activeTab === 'invites' && !!selectedInvite);

    const handleBack = () => {
        if (activeTab === 'chats') handleSelectContact(null);
        else if (activeTab === 'groups') setSelectedGroup(null);
        else if (activeTab === 'invites') handleSelectInvite(null);
    };

    return (
        <div className="flex flex-col h-full overflow-hidden bg-white">
            <div className="flex flex-1 min-h-0 overflow-hidden relative">
                <div
                    className={`flex flex-col w-full lg:w-auto lg:relative lg:inset-auto lg:translate-x-0 lg:z-10 absolute inset-0 z-10 bg-white transition-transform duration-300 ease-in-out ${
                        hasChatSelected ? '-translate-x-full lg:translate-x-0' : 'translate-x-0'
                    }`}
                >
                    <div className="flex-1 overflow-hidden">
                        <ChatSidebar
                            activeTab={activeTab}
                            setActiveTab={setActiveTab}
                            inviteSubTab={inviteSubTab}
                            setInviteSubTab={setInviteSubTab}
                            contacts={contacts}
                            loading={loading}
                            chatRooms={chatRooms}
                            filteredChatRooms={filteredChatRooms}
                            invites={invites}
                            myInvites={myInvites}
                            invitesLoading={invitesLoading}
                            selectedUser={selectedUser}
                            selectedGroup={selectedGroup}
                            selectedInvite={selectedInvite}
                            handleSelectContact={handleSelectContact}
                            handleSelectGroup={handleSelectGroup}
                            handleSelectInvite={handleSelectInvite}
                            setShowGroupModal={setShowGroupModal}
                            setSelectedGroup={setSelectedGroup}
                            handleFetchMyInvites={handleFetchMyInvites}
                            handleFetchAllRequests={handleFetchAllRequests}
                            getLastMessageDisplay={getLastMessageDisplay}
                            getLastMessageDisplayForChatRoom={getLastMessageDisplayForChatRoom}
                            formatText={formatText}
                            handleAcceptInvite={handleAcceptInvite}
                            handleDeclineInvite={handleDeclineInvite}
                            loggedInUserName={loggedInUserName}
                        />
                    </div>
                </div>

                <div
                    className={`flex flex-col w-full lg:flex-1 lg:relative lg:inset-auto lg:translate-x-0 lg:z-10 absolute inset-0 z-20 bg-white transition-transform duration-300 ease-in-out h-full overflow-hidden ${
                        hasChatSelected ? 'translate-x-0' : 'translate-x-full lg:translate-x-0'
                    }`}
                >
                    {activeTab === 'invites' && selectedInvite ? (
                        <>
                            <div className="lg:hidden sticky top-0 z-10 flex items-center gap-3 px-4 py-3 border-b border-gray-100 bg-white shrink-0">
                                <button
                                    type="button"
                                    onClick={handleBack}
                                    className="w-9 h-9 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors"
                                >
                                    <svg className="w-5 h-5 text-gray-700" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
                                    </svg>
                                </button>
                                <span className="text-base font-semibold font-['Plus_Jakarta_Sans'] text-gray-900">
                                    {t('invitesTab', 'Invites')}
                                </span>
                            </div>
                            <ChatMessages
                                selectedChatType={selectedChatType}
                                selectedInvite={selectedInvite}
                                messages={messages}
                                fetchingMessages={fetchingMessages}
                                connectStatus={connectStatus}
                                setConnectStatus={setConnectStatus}
                                isDragging={isDragging}
                                handleAcceptInvite={handleAcceptInvite}
                                handleDeclineInvite={handleDeclineInvite}
                                chatAreaRef={chatAreaRef}
                                messagesEndRef={messagesEndRef}
                                isMessageFromCurrentUser={isMessageFromCurrentUser}
                                selectedImage={selectedImage}
                                setSelectedImage={setSelectedImage}
                                selectedVideo={selectedVideo}
                                setSelectedVideo={setSelectedVideo}
                                imageCarousel={imageCarousel}
                                setImageCarousel={setImageCarousel}
                                handleWithdrawDeal={handleWithdrawDeal}
                                dealProcessing={dealProcessing}
                                getCurrentUserRole={getCurrentUserRole}
                                loggedInUserName={loggedInUserName}
                                selectedUser={selectedUser}
                                selectedGroup={selectedGroup}
                                setSelectedDealForView={setSelectedDealForView}
                                setShowViewDealModal={setShowViewDealModal}
                                setShowModal={setShowModal}
                                formatText={formatText}
                                onViewProfile={onViewProfile}
                            />
                        </>
                    ) : activeTab === 'chats' && selectedUser ? (
                        <>
                            <div className="lg:hidden sticky top-0 z-10 flex items-center gap-3 px-4 py-3 border-b border-gray-100 bg-white shrink-0">
                                <button
                                    type="button"
                                    onClick={handleBack}
                                    className="w-9 h-9 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors shrink-0"
                                >
                                    <svg className="w-5 h-5 text-gray-700" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
                                    </svg>
                                </button>
                                <div className="flex items-center gap-2.5 flex-1 min-w-0">
                                    <div className="w-8 h-8 rounded-full overflow-hidden shrink-0 bg-gray-100">
                                        {selectedUser.profileDto.profileImage ? (
                                            <img src={selectedUser.profileDto.profileImage} alt="" className="w-full h-full object-cover" />
                                        ) : (
                                            <div className="w-full h-full flex items-center justify-center text-gray-500 text-sm font-medium">
                                                {selectedUser.profileDto.firstName?.[0]}
                                            </div>
                                        )}
                                    </div>
                                    <div className="min-w-0">
                                        <p className="text-sm font-semibold font-['Plus_Jakarta_Sans'] text-gray-900 truncate leading-5">
                                            {selectedUser.profileDto.firstName} {selectedUser.profileDto.lastName}
                                        </p>
                                        <p className="text-sm font-normal font-['Plus_Jakarta_Sans'] leading-5 text-green-600">{t('online', 'Online')}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="hidden lg:block">
                                <ChatHeader
                                    selectedUser={selectedUser}
                                    selectedGroup={selectedGroup}
                                    fetchingMessages={fetchingMessages}
                                    showGroupInfoModal={showGroupInfoModal}
                                    setShowGroupInfoModal={setShowGroupInfoModal}
                                    groupInfoRef={groupInfoRef}
                                    isAddMemberOpen={isAddMemberOpen}
                                    setIsAddMemberOpen={setIsAddMemberOpen}
                                    handleAddPeople={handleAddPeople}
                                    getAllMembers={getAllMembers}
                                    handleRefreshFlag={handleRefreshFlag}
                                    showRemoveConfirm={showRemoveConfirm}
                                    setShowRemoveConfirm={setShowRemoveConfirm}
                                    memberToRemove={memberToRemove}
                                    setMemberToRemove={setMemberToRemove}
                                    fetchGroupMessages={fetchGroupMessages}
                                    loggedInUserName={loggedInUserName}
                                    showLeaveConfirm={showLeaveConfirm}
                                    setShowLeaveConfirm={setShowLeaveConfirm}
                                    setShowGroupModal={setShowGroupModal}
                                    setSelectedGroup={setSelectedGroup}
                                    handleLeaveGroup={handleLeaveGroup}
                                    isLeaving={isLeaving}
                                    setIsLeaving={setIsLeaving}
                                    selectedChatType={selectedChatType}
                                    onViewProfile={onViewProfile}
                                />
                            </div>
                            <ChatMessages
                                selectedChatType={selectedChatType}
                                selectedInvite={selectedInvite}
                                messages={messages}
                                connectStatus={connectStatus}
                                setConnectStatus={setConnectStatus}
                                fetchingMessages={fetchingMessages}
                                isDragging={isDragging}
                                handleAcceptInvite={handleAcceptInvite}
                                handleDeclineInvite={handleDeclineInvite}
                                chatAreaRef={chatAreaRef}
                                messagesEndRef={messagesEndRef}
                                isMessageFromCurrentUser={isMessageFromCurrentUser}
                                selectedImage={selectedImage}
                                setSelectedImage={setSelectedImage}
                                selectedVideo={selectedVideo}
                                setSelectedVideo={setSelectedVideo}
                                imageCarousel={imageCarousel}
                                setImageCarousel={setImageCarousel}
                                handleWithdrawDeal={handleWithdrawDeal}
                                dealProcessing={dealProcessing}
                                getCurrentUserRole={getCurrentUserRole}
                                loggedInUserName={loggedInUserName}
                                selectedUser={selectedUser}
                                selectedGroup={selectedGroup}
                                setSelectedDealForView={setSelectedDealForView}
                                setShowViewDealModal={setShowViewDealModal}
                                setShowModal={setShowModal}
                                formatText={formatText}
                                onViewProfile={onViewProfile}
                            />
                            <ChatInput
                                message={message}
                                setMessage={setMessage}
                                selectedFiles={selectedFiles}
                                sending={sending}
                                uploadingFiles={uploadingFiles}
                                handleSendMessage={handleSendMessage}
                                handleKeyPress={handleKeyPress}
                                handleFileSelect={handleFileSelect}
                                removeFile={removeFile}
                                clearFileSelection={clearFileSelection}
                                fileInputRef={fileInputRef}
                                showEmojiPicker={showEmojiPicker}
                                setShowEmojiPicker={setShowEmojiPicker}
                                inputAreaRef={inputAreaRef}
                                MAX_CHAR_LIMIT={MAX_CHAR_LIMIT}
                                getCurrentUserRole={getCurrentUserRole}
                                showModal={showModal}
                                setShowModal={setShowModal}
                                selectedUser={selectedUser}
                                selectedGroup={selectedGroup}
                                selectedChatType={selectedChatType}
                                selectedDealForView={selectedDealForView}
                                setSelectedDealForView={setSelectedDealForView}
                                fetchMessages={fetchMessages}
                                fetchGroupMessages={fetchGroupMessages}
                            />
                        </>
                    ) : activeTab === 'groups' && selectedGroup ? (
                        <>
                            <div className="lg:hidden sticky top-0 z-10 flex items-center gap-3 px-4 py-3 border-b border-gray-100 bg-white shrink-0">
                                <button
                                    type="button"
                                    onClick={handleBack}
                                    className="w-9 h-9 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors shrink-0"
                                >
                                    <svg className="w-5 h-5 text-gray-700" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
                                    </svg>
                                </button>
                                <div className="flex items-center gap-2.5 flex-1 min-w-0">
                                    <div className="w-8 h-8 rounded-full overflow-hidden shrink-0 bg-gray-100 flex items-center justify-center text-gray-500">
                                        {selectedGroup.profileImage ? (
                                            <img src={selectedGroup.profileImage} alt="" className="w-full h-full object-cover" />
                                        ) : (
                                            <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M18 18.72a9.094 9.094 0 0 0 3.741-.479 3 3 0 0 0-4.682-2.72m.94 3.198.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 0 1 6 18.719m12 0a5.971 5.971 0 0 0-.941-3.197m0 0A5.995 5.995 0 0 0 12 12.75a5.995 5.995 0 0 0-5.058 2.772m0 0a3 3 0 0 0-4.681 2.72 8.986 8.986 0 0 0 3.74.477m.94-3.197a5.971 5.971 0 0 0-.94 3.197M15 6.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm6 3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm-13.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z" />
                                            </svg>
                                        )}
                                    </div>
                                    <div className="min-w-0">
                                        <p className="text-sm font-semibold font-['Plus_Jakarta_Sans'] text-gray-900 truncate leading-5">
                                            {selectedGroup.name}
                                        </p>
                                        <p className="text-xs text-gray-400 leading-4">
                                            {selectedGroup.members?.length ?? 0} {t('members', 'members')}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="hidden lg:block">
                                <ChatHeader
                                    selectedUser={selectedUser}
                                    selectedGroup={selectedGroup}
                                    fetchingMessages={fetchingMessages}
                                    showGroupInfoModal={showGroupInfoModal}
                                    setShowGroupInfoModal={setShowGroupInfoModal}
                                    groupInfoRef={groupInfoRef}
                                    isAddMemberOpen={isAddMemberOpen}
                                    setIsAddMemberOpen={setIsAddMemberOpen}
                                    handleAddPeople={handleAddPeople}
                                    getAllMembers={getAllMembers}
                                    handleRefreshFlag={handleRefreshFlag}
                                    showRemoveConfirm={showRemoveConfirm}
                                    setShowRemoveConfirm={setShowRemoveConfirm}
                                    memberToRemove={memberToRemove}
                                    setMemberToRemove={setMemberToRemove}
                                    fetchGroupMessages={fetchGroupMessages}
                                    loggedInUserName={loggedInUserName}
                                    showLeaveConfirm={showLeaveConfirm}
                                    setShowLeaveConfirm={setShowLeaveConfirm}
                                    setShowGroupModal={setShowGroupModal}
                                    setSelectedGroup={setSelectedGroup}
                                    handleLeaveGroup={handleLeaveGroup}
                                    isLeaving={isLeaving}
                                    setIsLeaving={setIsLeaving}
                                    selectedChatType={selectedChatType}
                                    onViewProfile={onViewProfile}
                                />
                            </div>
                            <ChatMessages
                                selectedChatType={selectedChatType}
                                selectedInvite={selectedInvite}
                                messages={messages}
                                fetchingMessages={fetchingMessages}
                                connectStatus={connectStatus}
                                setConnectStatus={setConnectStatus}
                                isDragging={isDragging}
                                handleAcceptInvite={handleAcceptInvite}
                                handleDeclineInvite={handleDeclineInvite}
                                chatAreaRef={chatAreaRef}
                                messagesEndRef={messagesEndRef}
                                isMessageFromCurrentUser={isMessageFromCurrentUser}
                                selectedImage={selectedImage}
                                setSelectedImage={setSelectedImage}
                                selectedVideo={selectedVideo}
                                setSelectedVideo={setSelectedVideo}
                                imageCarousel={imageCarousel}
                                setImageCarousel={setImageCarousel}
                                handleWithdrawDeal={handleWithdrawDeal}
                                dealProcessing={dealProcessing}
                                getCurrentUserRole={getCurrentUserRole}
                                loggedInUserName={loggedInUserName}
                                selectedUser={selectedUser}
                                selectedGroup={selectedGroup}
                                setSelectedDealForView={setSelectedDealForView}
                                setShowViewDealModal={setShowViewDealModal}
                                setShowModal={setShowModal}
                                formatText={formatText}
                                onViewProfile={onViewProfile}
                            />
                            <ChatInput
                                message={message}
                                setMessage={setMessage}
                                selectedFiles={selectedFiles}
                                sending={sending}
                                uploadingFiles={uploadingFiles}
                                handleSendMessage={handleSendMessage}
                                handleKeyPress={handleKeyPress}
                                handleFileSelect={handleFileSelect}
                                removeFile={removeFile}
                                clearFileSelection={clearFileSelection}
                                fileInputRef={fileInputRef}
                                showEmojiPicker={showEmojiPicker}
                                setShowEmojiPicker={setShowEmojiPicker}
                                inputAreaRef={inputAreaRef}
                                MAX_CHAR_LIMIT={MAX_CHAR_LIMIT}
                                getCurrentUserRole={getCurrentUserRole}
                                showModal={showModal}
                                setShowModal={setShowModal}
                                selectedUser={selectedUser}
                                selectedGroup={selectedGroup}
                                selectedChatType={selectedChatType}
                                selectedDealForView={selectedDealForView}
                                setSelectedDealForView={setSelectedDealForView}
                                fetchMessages={fetchMessages}
                                fetchGroupMessages={fetchGroupMessages}
                            />
                        </>
                    ) : (
                        <div className="hidden lg:flex flex-1 flex-col">
                            <ChatEmptyState
                                variant="panel"
                                icon={noMessagesEmptyIcon}
                                title={
                                    activeTab === 'invites'
                                        ? t('selectInvite', 'Select invite')
                                        : activeTab === 'groups'
                                            ? (filteredChatRooms?.length
                                                ? t('selectGroup', 'Select group')
                                                : t('noGroupMessagesYet', 'No group messages yet'))
                                            : (contacts?.contactDetailsResponseDtos?.length
                                                ? t('selectContactOrGroup', 'Select conversation')
                                                : t('noChatMessagesYet', 'No chat messages yet'))
                                }
                                subtitle={
                                    activeTab === 'invites'
                                        ? t('chooseInviteToView', 'Choose invite to view')
                                        : activeTab === 'groups'
                                            ? (filteredChatRooms?.length ? t('chooseGroupToChat', 'Choose group to chat') : undefined)
                                            : (contacts?.contactDetailsResponseDtos?.length ? t('chooseSomeoneToChat', 'Choose someone to chat') : undefined)
                                }
                            />
                        </div>
                    )}
                </div>
            </div>

            <ChatModals
                showGroupModal={showGroupModal}
                setShowGroupModal={setShowGroupModal}
                selectedGroup={selectedGroup}
                setSelectedGroup={setSelectedGroup}
                handleRefreshFlag={handleRefreshFlag}
                showViewDealModal={showViewDealModal}
                setShowViewDealModal={setShowViewDealModal}
                viewDealHighlightSection={viewDealHighlightSection}
                setViewDealHighlightSection={setViewDealHighlightSection}
                selectedDealForView={selectedDealForView}
                onViewProfile={onViewProfile}
            />
        </div>
    );
};
